<template>
  <div id="about-form">
    <v-container>
    <v-flex xs12 sm8 md6>
    <p>{{ formTitle }}</p>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="name"
        label="Name"
      ></v-text-field> 
      <v-checkbox
        :label="`Youtube Video?: ${isYoutubeLink.toString()}`"
        v-model="isYoutubeLink"
      ></v-checkbox>
      <v-text-field
        v-model="youtubeLink"
        label="Youtube Link"
      ></v-text-field> 
      Thumbnail <input type="file" @change="onFileChange" id="file" name="file" required>
      <div v-if="imageFile">
        <img :src="imageFile" style="max-width:300px;max-height:300px;"/>
        <v-icon @click="removeImage">fa-times</v-icon>
      </div><br>
      Video <input type="file" @change="onFileChange" id="videofile" name="videofile" required>
      <div v-if="videoFile">
        <video v-if="!isYoutubeLink" :src="videoFile" style="max-width:300px;max-height:300px;"></video>
        <iframe v-else width="560" height="315" :src="youtubeLink" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        <v-icon @click="removeImage">fa-times</v-icon>
      </div><br>
      <v-btn :disabled="!valid" @click="submit" color="primary">{{ buttonName }}</v-btn>
      <v-btn @click="clear" dark>Clear</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="goBack" dark>Back</v-btn>
    </v-form>
    </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['buttonName', 'editData', 'formTitle'],
  data () {
    return {
      id: null,
      valid: true,
      name: '',
      imageFile: '',
      videoFile: '',
      isYoutubeLink: false,
      youtubeLink: ''
    }
  },
  beforeMount () {
    if (this.editData) {
      this.id = this.editData.id
      this.name = this.editData.name
      this.imageFile = this.editData.thumbnail
      this.videoFile = this.editData.video
      this.isYoutubeLink = this.editData.is_youtube_link
      this.youtubeLink = this.editData.youtube_link
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'adminUser/getLoggedInUser'
    })
  },
  methods: {
    submit () {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          const data = {
            id: this.id,
            name: this.name,
            is_youtube_link: this.isYoutubeLink,
            youtube_link: this.youtubeLink,
            current_user: this.currentUser
          }
          const imageInput = this.$el.querySelector('#file')
          const videoInput = this.$el.querySelector('#videofile')
          this.$emit('addItem', data, imageInput, videoInput)
        }
      } else {
        if (this.$refs.form.validate()) {
          const data = {
            id: this.id,
            name: this.name,
            is_youtube_link: this.isYoutubeLink,
            youtube_link: this.youtubeLink,
            current_user: this.currentUser
          }
          const imageInput = this.$el.querySelector('#file')
          const videoInput = this.$el.querySelector('#videofile')
          this.$emit('updateItem', this.editData.id, data, imageInput, videoInput)
        }
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    goBack () {
      this.$emit('goBack')
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.imageFile = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage (e) {
      const imageInput = this.$el.querySelector('#file')
      imageInput.value = ''
      this.imageFile = ''
    },
    removeVideo (e) {
      const videoInput = this.$el.querySelector('#videofile')
      videoInput.value = ''
      this.videoFile = ''
      this.isYoutubeLink = false
      this.youtubeLink = ''
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/VideoGalleryInputForm.vue